import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ProtectionLayer from './ProtectionLayer';
import { LanguageProvider } from './LanguageContext';
import { ThemeProvider } from './ThemeContext';
// Import global CSS so Vite bundles it
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <ProtectionLayer>
          <App />
        </ProtectionLayer>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);